export default __webpack_public_path__ + "static/media/Left_Arrow.62c29b91.svg";